import React, { Component } from 'react';
import { connect } from 'react-redux';

import { createPaymentType } from '../actions/PaymentTypeActions';

import { Pane, Heading, Button } from 'evergreen-ui';
import InfoBlock from '../../common/InfoBlock/InfoBlock';

import { Link } from 'react-router-dom';
import PaymentTypeForm from '../components/PaymentTypeForm';

import Configuration from '../Config';

const validation = Configuration.Validations.paymentType;
const defaultValues = Configuration.Defaults.createPaymentType;
const mapValidationErrors = Configuration.ErrorHandler.mapValidationErrors;

class CreatePaymentType extends Component {
    componentDidMount() {
       
    }

    handleSave = (values) => {
        this.props.dispatch(createPaymentType(values));
    }

    render() {
        return (
            <Pane padding={16} paddingTop={0}>
                <Pane display="flex">
                    <Pane>
                        <Link to="/payment-types">
                            <Button iconBefore="arrow-left" intent="none">
                                Inapoi la lista modalitati de plata
                            </Button>
                        </Link>
                    </Pane>
                </Pane>

                <Pane flex={1} background="tint1" elevation={1} padding={16} marginTop={16}>
                    <Heading size={600}>
                        Modalitate de plata noua
                    </Heading>
                </Pane>
                
                <Pane display="flex" justifyContent="space-between" flex={1} marginTop={16}>
                    <InfoBlock flex="1">
                        <PaymentTypeForm 
                            isEdit={false}
                            initialValues={defaultValues}
                            validationSchema={validation}
                            onSave={this.handleSave}
                            errors={this.props.errors}/>
                    </InfoBlock>
                </Pane>

            </Pane>
        )
    }
}

function mapStateToProps(state) {
    return {
        errors: state.paymentTypes.errors.type === 'validation' ? mapValidationErrors(state.paymentTypes.errors.fields): [],
    }
}

export default connect(mapStateToProps)(CreatePaymentType);